export function Pagination({
  page, pages, total, taille, onPage,
}: {
  page: number; pages: number; total: number; taille: number; onPage: (p: number) => void;
}) {
  if (total === 0) return null;
  const premier = (page - 1) * taille + 1;
  const dernier = Math.min(page * taille, total);

  return (
    <nav className="pagination" aria-label="Pagination">
      <button type="button" className="btn sm" onClick={() => onPage(page - 1)} disabled={page <= 1}>
        Précédent
      </button>
      <span aria-live="polite">
        {premier}–{dernier} sur {total}
        {pages > 1 && ` · page ${page} / ${pages}`}
      </span>
      <button type="button" className="btn sm" onClick={() => onPage(page + 1)} disabled={page >= pages}>
        Suivant
      </button>
    </nav>
  );
}
